import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Row, Col, Button, Carousel } from 'react-bootstrap';
import favicon from '../assets/Guide Snapshots/favico.png';
import DasboardImg from '../assets/Guide Snapshots/Dashboard.png';
import AddUrl from '../assets/Guide Snapshots/Event Url.png';
import AddFilter from '../assets/Guide Snapshots/Add Filter.png';
import saveFilter from '../assets/Guide Snapshots/save filter.png';
import editFilter from '../assets/Guide Snapshots/Edit Filter.png';
import activateEvent from '../assets/Guide Snapshots/Activate Event.png';
import notificaiton from '../assets/Guide Snapshots/notification.png';
import liveFeed from '../assets/Guide Snapshots/live feed.png';
import livedrop from '../assets/Guide Snapshots/livedrop.png';
import upcoming from '../assets/Guide Snapshots/upcomingevent.png';
import settings from '../assets/Guide Snapshots/settings.png';
import settingsAlert from '../assets/Guide Snapshots/settingAlert.png';



export default function Guide({ show, onHide }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <div className='align-items-center d-flex gap-2'>
                    <img src={favicon} alt="Beta Tickets Info Logo" width={'40px'} />
                    <Modal.Title>User Guide</Modal.Title>
                </div>

            </Modal.Header>

            <Modal.Body>
                <Carousel interval={null} indicators={true} controls={true}>
                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Welcome to Beta Tickets Info</h5>
                            <p className='px-3'>
                                This guide will help you understand how to use the application
                                efficiently.
                                <br />
                                The Dashboard is the central control panel of DropChecker. From here, you can add
                                new events using a URL, edit existing events, and select or deselect events to control
                                which ones are actively monitored.
                            </p>
                            <img src={DasboardImg} alt="Dashboard" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Adding Event Url</h5>
                            <p className='px-3'>
                                Enter the event URL in the designated URL field on the Dashboard, then click the
                                'Add URL' button to add the event.
                            </p>
                            <img src={AddUrl} alt="Add URL" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Adding Filters</h5>
                            <p className='px-3'>
                                After adding an event, you may notice a blank row appearing in the table. This is
                                completely normal. Simply click on the “Filter” button to begin adding your desired
                                filters.
                            </p>
                            <img src={AddFilter} alt="Edit Filter" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Save Filter Values</h5>
                            <p className='px-3'>
                                Once you have selected your preferred section, price range, seat selection, and ticket
                                type,<br />click the “Add Filter” button to apply and save the filter settings.
                                <br />
                                After clicking “Add Filter”, select “Save Filter” to confirm and apply the selected
                                filter settings.
                            </p>
                            <img src={saveFilter} alt="Save Filter" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>View Saved Filters</h5>
                            <p className='px-3'>
                                Once saved, the previously blank row will now display your configured filters, and
                                the event will appear properly listed on the dashboard
                            </p>
                            <img src={editFilter} alt="Edit Filter" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Activate Events</h5>
                            <p className='px-3'>
                                Events are automatically activated upon being added and will begin monitoring
                                immediately. To activate an event that is currently unmonitored, select the
                                corresponding checkbox and click “Activate Event.”
                                The Dashboard will display all events—both monitored and unmonitored—allowing
                                you to edit or modify them at any time as needed.
                            </p>
                            <img src={activateEvent} alt="Activate Event" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h4>Drop Notification</h4>
                            <p className='px-3'>
                                Access new notification alerts, customize the appearance from the top menu (Light
                                Mode / Dark Mode), and securely log out of your account
                            </p>
                            <img src={notificaiton} alt="Edit Filter" className="img-fluid" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>View Live Feed</h5>
                            <p className='px-3'>
                                Next, click the “Live Feed” button to access the Live Feed page. This page displays
                                all detected drops for the events currently being monitored. You will also continue to
                                receive drop notifications via email and SMS, ensuring you stay updated in real time.
                            </p>
                            <img src={liveFeed} alt="Live Feed" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>View Drop Details</h5>
                            <p className='px-3'>
                                Click on any drop entry to view detailed information, including the seat, price, ticket
                                type, and the event link.
                                Select the event link to open the event instantly, allowing you to proceed with carting
                                the available seat.
                            </p>
                            <img src={livedrop} alt="Live Feed" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>UpComing Events</h5>
                            <p className='px-3'>
                                The Upcoming Events page allows you to search for events directly, without needing
                                a URL. You can search by event name, venue, city, or state.
                                From this page, you can browse the search results and add events directly to your
                                Dashboard if a URL is not available.
                            </p>
                            <img src={upcoming} alt="Upcoming Events" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Settings - Genral Tab</h5>
                            <p className='px-3'>
                                In the Settings page- General section, you can manage how you receive notifications:
                                <br />
                                <strong>AddEmails</strong> - Enterone or more email addresses to receive drop alerts. <br />
                                <strong>AddPhoneNumbers</strong> - Enter oneor more phone numbers to receive SMS
                                notifications.
                            </p>


                            <img src={settings} alt="Settings" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="pt-0 p-4 text-center">
                            <h5>Settings - Alert Tab</h5>
                            <p className='px-3'>
                                In the Settings page- Alerts section, you can manage your notification preferences:
                                <br />
                                <strong>Email Alerts</strong> - Turn email notifications on or off according
                                to your preference.
                                <br />
                                <strong>SMS Alerts</strong> - Turn SMS notifications on or off for instant
                                updates.
                            </p>
                            <img src={settingsAlert} alt="Settings" className="img-fluid px-3" />
                        </div>
                    </Carousel.Item>
                </Carousel>
            </Modal.Body>
        </Modal>
    )
}
